module.exports = __webpack_public_path__ + "static/Resume_Lee_Allen-4945576c9be92a7c51ae0ce92edbe8e5.pdf";